import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import moment from 'moment';
import { cloneDeep } from 'lodash';
import { forkJoin } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

//Services
import { EmployeeInfoService } from '../../../core/services/employee-info.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { EmployeeService } from './../../../pages/employee/services/employee.service';
import { ApprovalService } from './../../../pages/approval/services/approval.service';
import { UtilityService } from '../../../core/services/utility.service';

@Component({
  selector: 'app-edit-dependent-modal',
  templateUrl: './edit-dependent-modal.component.html',
  styleUrls: ['./edit-dependent-modal.component.css'],
})
export class EditDependentModalComponent implements OnInit {
  @ViewChild('dependForm', { static: false }) dependForm: NgForm;
  @Input() dependent: any;
  @Input() mode: string;
  @Input() userID: number | null;
  mobileMode: boolean;
  portalSettings: any;
  employeeInfo: any;
  format: string;
  formData: { [key: string]: any } = {};
  originalData: { [key: string]: any } = {};
  gettingFilesData = false;
  savingDependent = false;
  btmText: any;
  newBornSSN: boolean;
  docsRequired: boolean;
  phoneMask: any;
  ssnMask: any;
  attachedFiles: number;
  savedFiles: any[];
  newFiles: any[];
  fileData: any[];
  relationshipList: any[] = [];
  hRDPKeyID: number;
  keyID: number;
  fields: any[] = [];
  groupedFields: any[] = [];
  dependentRequestID: number;
  isSubmitting: boolean;
  alert: any;
  validComboDrag: any;
  dragFiles: any;
  isLoading = true;
  fieldsToBind = 0;
  datePickerOptions: any;
  ssnNotRequireOverride: boolean;

  constructor(
    public activeModal: NgbActiveModal,
    portalSettingsService: PortalSettingsService,
    employeeInfoService: EmployeeInfoService,
    private employeeService: EmployeeService,
    private approvalService: ApprovalService,
    private utilityService: UtilityService
  ) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
  }

  ngOnInit(): void {
    this.format = this.utilityService.getDateFormat().toUpperCase();
    this.datePickerOptions = this.utilityService.getDefaultDatepickerOptions();
    this.mobileMode = this.utilityService.isMobileMode();
    this.btmText = this.portalSettings.DependentBtmText.ConfigValue;
    this.newBornSSN = this.portalSettings.NewBorn30SSNNotRequire.ConfigValue == '1';
    this.docsRequired = this.portalSettings.DependentRequiresDocs.ConfigValue == '1';
    this.formData = {};
    this.originalData = {};
    this.savingDependent = false;
    this.phoneMask = this.portalSettings.PhoneMask.ConfigValue;
    this.formData.notes = '';
    //set SSN Mask
    switch (this.employeeInfo.EmplCountry) {
      case 'US':
        this.ssnMask = '999-99-9999';
        break;
      case 'CA':
        this.ssnMask = '999-999-999';
        break;
      default:
        this.ssnMask = '999-99-9999';
        break;
    }
    this.attachedFiles = 0;
    this.savedFiles = [];
    this.hRDPKeyID = this.dependent.KeyID;
    this.getRelationship();
    if (this.mode == 'approval') this.keyID = this.dependent.HRDPKeyID;
    else if (this.mode == 'attachmentOnly') {
      this.keyID = this.dependent.DependentRequestID;
    } else this.keyID = this.dependent.KeyID;
    var isAddressValidationEnabled = false;
    this.newFiles = [];
  }

  private getRelationship() {
    this.employeeService.getRelationship().then((response: any) => {
      this.relationshipList = [];
      response.forEach((val: any) => {
        this.relationshipList.push({ name: val, value: val });
      });
      this.getUserFields();
    });
  }

  checkSSN(field) {
    if (this.formData[field.FieldVPColumnName] != null) {
      if (this.formData[field.FieldVPColumnName].length != 11) this.formData[field.FieldVPColumnName] = null;
    }
  }

  addAttachment() {
    this.newFiles.push({ File: null, Filename: null });
  }

  deleteUnsavedAttachment = function (file) {
    var index = this.newFiles.indexOf(file);
    this.newFiles.splice(index, 1);
  };

  numDaysBetween(d1, d2) {
    var diff = Math.abs(d1.getTime() - d2.getTime());
    return diff / (1000 * 60 * 60 * 24);
  }

  check30Days = function (data) {
    if (data != null) {
      if (this.newBornSSN) {
        if (this.numDaysBetween(new Date(), data) < 31) this.ssnNotRequireOverride = true;
        else this.ssnNotRequireOverride = false;
      }
    }
  };

  private getUserFields() {
    this.employeeService.getDependentFields(this.keyID).then((response: any) => {
      this.fields = response;
      this.groupedFields = [];
      var temp = [];
      for (var i = 0; i < this.fields.length; i++) {
        if (this.fields[i].FieldDataType == 4) {
          if (this.fields[i].FieldValue != null) {
            var dateParts = this.fields[i].FieldValue.split('-');
            var date = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
            date.setHours(0, 0, 0, 0);
            this.formData[this.fields[i].FieldVPColumnName] = date;
            this.check30Days(date);
          }
        } else {
          if (this.fields[i].FieldDataType == 5) {
            this.fieldsToBind++;
            this.getFieldOptions(this.fields[i]);
          }
          if (this.fields[i].FieldVPColumnName == 'Relationship') {
            if (this.relationshipList.length > 0) {
              for (let j = 0; j < this.relationshipList.length; j++) {
                if (this.relationshipList[j].value == this.fields[i].FieldValue) {
                  this.formData[this.fields[i].FieldVPColumnName] = this.fields[i].FieldValue;
                  break;
                } else {
                  this.formData[this.fields[i].FieldVPColumnName] = null;
                }
              }
            } else {
              this.formData[this.fields[i].FieldVPColumnName] = this.fields[i].FieldValue;
            }
          } else this.formData[this.fields[i].FieldVPColumnName] = this.fields[i].FieldValue;
        }
        if (i > 0 && i % 2 == 0) {
          this.groupedFields.push(temp);
          temp = [];
        }
        temp.push(this.fields[i]);
      }
      if (this.mode == 'approval') {
        if (this.dependent.DependentFieldData != '') {
          var dependentFieldData = this.dependent.DependentFieldData.DependentInformation.DependentField;
          //if only one field has changed, dependentFieldData is an object, else it is an array
          if (Object.prototype.toString.call(dependentFieldData) === '[object Array]') {
            dependentFieldData.forEach((val: any) => {
              if (val.Name == 'BirthDate') {
                this.formData[val.Name] = new Date(
                  parseInt(moment(val.Value).format('YYYY')),
                  parseInt(moment(val.Value).format('MM')) - 1,
                  parseInt(moment(val.Value).format('DD')),
                  0,
                  0,
                  0,
                  0
                );
              }
              //#410452: Handling other dates fields in the screen
              else if (moment(val.Value, 'YYYY-MM-DD', true).isValid()) {
                this.formData[val.Name] = new Date(
                  parseInt(moment(val.Value).format('YYYY')),
                  parseInt(moment(val.Value).format('MM')) - 1,
                  parseInt(moment(val.Value).format('DD')),
                  0,
                  0,
                  0,
                  0
                );
              } else {
                this.formData[val.Name] = val.Value;
              }
            });
          } else {
            if (dependentFieldData.Name != null && dependentFieldData.Value != null) {
              if (dependentFieldData.Name == 'BirthDate') {
                this.formData[dependentFieldData.Name] = new Date(
                  parseInt(moment(dependentFieldData.Value).format('YYYY')),
                  parseInt(moment(dependentFieldData.Value).format('MM')) - 1,
                  parseInt(moment(dependentFieldData.Value).format('DD')),
                  0,
                  0,
                  0,
                  0
                );
              }
              if (moment(dependentFieldData.Value, 'YYYY-MM-DD', true).isValid()) {
                this.formData[dependentFieldData.Name] = new Date(
                  parseInt(moment(dependentFieldData.Value).format('YYYY')),
                  parseInt(moment(dependentFieldData.Value).format('MM')) - 1,
                  parseInt(moment(dependentFieldData.Value).format('DD')),
                  0,
                  0,
                  0,
                  0
                );
              } else {
                this.formData[dependentFieldData.Name] = dependentFieldData.Value;
              }
            }
          }
        }
        this.getSavedAttachments();
      }
      this.originalData = cloneDeep(this.formData);
      if (this.fieldsToBind == 0) {
        this.isLoading = false;
      }
      if (temp.length > 0) {
        this.groupedFields.push(temp);
      }
    });
  }

  getSavedAttachments() {
    var requestParam = 'moduleID=' + 29 + '&recordID=' + this.dependent.DependentRequestID;
    this.employeeService.getFileAttachmentList(requestParam).then((response: any) => {
      this.savedFiles = response;
    });
  }

  private getFieldOptions(field) {
    this.employeeService.getFieldOptions(field.FieldID).then((response: any) => {
      field.fieldOptions = [];
      field.fieldOptions[field.FieldVPColumnName] = response;
      this.fieldsToBind--;
      if (this.fieldsToBind == 0) {
        this.isLoading = false;
      }
    });
  }

  cancelClicked() {
    this.activeModal.close('close');
  }

  saveClicked() {
    this.savingDependent = true;
    this.closeAlert();
    var postData = [];
    var changedKeys = [];

    //Get changed data
    for (let [key, value] of Object.entries(this.formData)) {
      if (this.originalData[key] !== value && !this.areDatesEqual(this.originalData[key], value)) {
        if (key.toLowerCase().indexOf('date') > -1 && value != null) {
          //ISO date string is always in format of YYYY-MM-DDTHH:mm:ss.sssZ
          value = moment(value).toISOString(true);
          value = value.substr(0, value.indexOf('T'));
        }
        if (key.toLowerCase().indexOf('phone') > -1 && key.toLowerCase().indexOf('carrier') == -1) {
          if (value == this.phoneMask) {
            value = '';
          }
        }
        if (key != 'fileDrop') {
          postData.push({ Name: key, Value: value });
          changedKeys.push(key);
        }
      }
    }
    //If data was changed, submit
    this.isSubmitting = true;
    this.employeeService.submitDependents(this.dependent.KeyID, postData, false, this.userID).then((response: any) => {
      if (response.success) {
        this.dependentRequestID = response.dependentRequestID;
        if (this.dependentRequestID != null) {
          this.saveAttachments();
        } else {
          this.savingDependent = false;
          this.activeModal.close({ type: 'success', msg: 'Dependent information updated successfully.' });
        }
      } else {
        this.savingDependent = false;
        this.alert = { type: 'danger', msg: 'An error occurred while updating dependent information.' };
      }
    });
  }

  private readFile(file: any, call: any) {
    var reader = new FileReader();
    reader.onload = function (e) {
      return call(e, file.name);
    };
    reader.readAsDataURL(file);
  }

  upload() {
    this.fileData = [];
    var currentUpload = this.formData.fileDrop;
    this.formData.fileDrop = [];
    for (var i = 0; i < currentUpload.length; i++) {
      currentUpload[i].nameEdit = '';
      for (var y = 0; y < currentUpload[i].name.substr(0, currentUpload[i].name.lastIndexOf('.') + 1).length; y++) {
        if (
          currentUpload[i].name[y] != ' ' &&
          currentUpload[i].name[y] != '&' &&
          currentUpload[i].name[y] != '*' &&
          currentUpload[i].name[y] != ':' &&
          currentUpload[i].name[y] != ';' &&
          currentUpload[i].name[y] != '|' &&
          currentUpload[i].name[y] != '=' &&
          currentUpload[i].name[y] != ',' &&
          currentUpload[i].name[y] != '.' &&
          currentUpload[i].name[y] != '/' &&
          currentUpload[i].name[y] != '"' &&
          currentUpload[i].name[y] != '[' &&
          currentUpload[i].name[y] != ']'
        )
          currentUpload[i].nameEdit += currentUpload[i].name[y];
      }
      currentUpload[i].nameEdit += currentUpload[i].name.substr(currentUpload[i].name.lastIndexOf('.'), currentUpload[i].name.length);
    }

    if (currentUpload != null) {
      for (var i = 0; i < currentUpload.length; i++) {
        var n = 0;
        this.readFile(currentUpload[i], (e: any, fileName: string) => {
          setTimeout(() => {
            this.fileData.push({ data: e.target.result.toString().split(','), size: e.total, name: fileName });
            if (n == currentUpload.length - 1) {
              this.fileData.forEach((val: any) => {
                currentUpload.forEach((val2: any) => {
                  if (val2.size == val.size && val.name == val2.name) {
                    this.newFiles.push({ File: val.data[1], Filename: val2.nameEdit, Filedata: val2, Type: val.data[0].split('/')[0] });
                  }
                });
              });
            }
            n++;
          });
        });
      }
    }
  }

  saveAttachments() {
    var promises = [];
    if (this.mode == 'attachmentOnly' || this.mode == 'approval') {
      this.dependentRequestID = this.dependent.DependentRequestID;
    }
    this.newFiles.forEach((attachment: any) => {
      if (attachment.File != null && attachment.Filename != null) {
        promises.push(
          this.employeeService
            .saveFileAttachment(29, this.dependentRequestID, attachment.File, attachment.Filename, 'file', null, null, null)
            .then((response: any) => {})
        );
      }
    });
    forkJoin(promises).subscribe({
      complete: () => {
        this.savingDependent = false;
        this.activeModal.close({ type: 'success', msg: 'Dependent information updated successfully.' });
      },
    });
  }

  approveClicked() {
    this.gettingFilesData = true;
    this.closeAlert();
    var postData = [];
    var changedKeys = [];
    //Get changed data
    Object.entries(this.formData).forEach((val: any) => {
      if (this.originalData[val[0]] !== val[1] && !this.areDatesEqual(this.originalData[val[0]], val[1])) {
        //#410452: Handling other dates fields in the screen
        if (moment(val[1], 'YYYY-MM-DD', true).isValid()) {
          val[1] = moment(val[1]).format('YYYY-MM-DD');
        }
        postData.push({ Name: val[0], Value: val[1] });
        changedKeys.push(val[0]);
      }
    });

    this.isSubmitting = true;

    //toVPFile
    this.approvalService
      .dependentRequestAction(this.dependent.DependentRequestID, postData, 'A', this.formData.notes)
      .then((response: any) => {
        if (response.success) {
          this.saveAttachments();
          if (this.savedFiles.length > 0) {
            this.employeeService
              .sendFileAttachmentRawDataToVP(29, this.dependent.DependentRequestID, 'file', null, null, null, null)
              .then((response: any) => {
                this.gettingFilesData = false;
                if (response.success) {
                  this.activeModal.close({ type: 'success', msg: 'Dependent request approved.' });
                }
              });
          }
        } else {
          this.alert = { type: 'danger', msg: 'An error occurred while approving the request.' };
          this.gettingFilesData = false;
        }
      });
  }

  deleteClicked() {
    this.employeeService.submitDependents(this.dependent.KeyID, null, true, this.userID).then((response: any) => {
      this.activeModal.close({ type: 'danger', msg: 'Your request to remove a dependent has been submitted.' });
    });
  }

  rejectClicked() {
    this.approvalService.dependentRequestAction(this.dependent.DependentRequestID, [], 'R', this.formData.notes).then((response: any) => {
      if (response.success) {
        this.activeModal.close({ type: 'success', msg: 'Dependent request rejected.' });
      } else {
        this.alert = { type: 'danger', msg: 'An error occurred while rejecting the request.' };
      }
    });
  }

  areDatesEqual(date, date2) {
    return (!date && !date2) || (date && date2 && date.getMonth && date.getTime() === date2.getTime());
  }

  closeAlert() {
    this.alert = null;
  }

  updatePhone(data: string, field: any) {
    this.formData[field] = data;
  }

  updateSSN(data: string, field: any) {
    this.formData[field] = data;
  }
}
